import { AggregateDocsQuerySettings, AggregateDocsResponse, FetchEventsResponse } from './Types'
import httpClient from '../../../api/httpClient'
import { appendQueryString } from '../../../helpers/StringHelper'

/**
 * While normally the Services files exist all collectively in one place,
 * the CMS sub-project is intended to be broken out and moved to a separate web service
 * as we improve our dev-ops approach.
 *
 * As such, all of its content should be contained here in the cms subfolder of the components namespace.
 *
 * Do not refactor to move this to the same space as other component structure.
 *
 */

export async function FetchAggregateDocs(
  querySettings: AggregateDocsQuerySettings
): Promise<AggregateDocsResponse> {
  const path = appendQueryString('/cms/docs', querySettings)
  try {
    const response = await httpClient.get(path)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
